
import referral from './referral.json';
import content from './content.json';

export default {
  description: "Conéctate con la comunidad y comparte tus experiencias",
  referral,
  content
};
